import HotelCardTitle from './HotelCardTitle';

export default HotelCardTitle;
